export default {"src":"/_next/static/media/xmg.d06ade0e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};